var _path, _path2, _path3, _path4, _path5, _circle, _rect, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceIconsEoeun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 30,
    viewBox: "0 0 120 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.2945 20.7734H66.5245V22.0942C66.5245 22.8648 66.8285 23.6039 67.3695 24.1488C67.9106 24.6937 68.6444 24.9998 69.4095 24.9998C70.1747 24.9998 70.9085 24.6937 71.4495 24.1488C71.9906 23.6039 72.2945 22.8648 72.2945 22.0942V20.7734Z",
    fill: "url(#paint0_linear_668_56275)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.8682 13.3773C73.8682 11.2642 72.8191 8.22119 70.7209 8.22119C68.0961 8.22119 66 10.7359 66 13.3773C66 14.9954 66.1968 16.217 66.3494 17.1636C66.4458 17.7623 66.5245 18.2509 66.5245 18.6603H72.2945L72.8191 17.0754C72.9596 16.6507 73.1002 16.264 73.2306 15.905C73.5871 14.9243 73.8682 14.1508 73.8682 13.3773ZM70.8289 16.4076L70.7817 16.5471H68.3762L68.3363 16.2914C68.1769 15.2507 68.0982 14.3906 68.0982 13.3773C68.0982 11.7756 69.3781 10.3344 70.7209 10.3344C70.7838 10.3344 70.9622 10.4791 71.2161 10.9757C71.557 11.6414 71.77 12.5849 71.77 13.3773C71.77 13.7683 71.6336 14.1825 70.8289 16.4076Z",
    fill: "url(#paint1_linear_668_56275)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9044 19.4275L82.1321 18.1268L76.4502 17.1188L76.2215 18.4184C76.0886 19.1774 76.2606 19.9585 76.6995 20.5898C77.1385 21.2211 77.8084 21.6509 78.562 21.7847C79.3156 21.9185 80.0911 21.7453 80.7179 21.3033C81.3448 20.8612 81.7715 20.1864 81.9044 19.4275Z",
    fill: "url(#paint2_linear_668_56275)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9239 10.9346C84.3792 8.33328 82.7489 5.49106 80.164 5.0325C78.0973 4.66587 76.5394 7.4785 76.1753 9.55998C76.0424 10.3215 76.1858 11.133 76.3677 12.1621C76.4342 12.5379 76.5057 12.9428 76.5708 13.3848L76.8142 15.0373L82.4971 16.0464C82.5675 15.6428 82.7294 15.1748 82.9278 14.6014C83.241 13.6961 83.6452 12.5278 83.9239 10.9346ZM81.0306 13.6403C81.2036 13.1121 81.3463 12.6949 81.3484 12.6896C81.5603 11.9944 81.7271 11.3129 81.8572 10.568C82.1331 8.99154 81.1207 7.34854 79.7989 7.11292C79.737 7.10236 79.5366 7.2133 79.2009 7.65707C78.7498 8.25404 78.3784 9.14685 78.241 9.92556C78.1801 10.2742 78.1896 10.3535 78.5242 12.3166C78.5715 12.5871 78.6103 12.8301 78.6459 13.0742L78.6669 13.22L81.0306 13.6403Z",
    fill: "url(#paint3_linear_668_56275)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 5H9C8.73478 5 8.48043 5.10536 8.29289 5.29289C8.10536 5.48043 8 5.73478 8 6V24C8 24.2652 8.10536 24.5196 8.29289 24.7071C8.48043 24.8946 8.73478 25 9 25H21C21.2652 25 21.5196 24.8946 21.7071 24.7071C21.8946 24.5196 22 24.2652 22 24V6C22 5.73478 21.8946 5.48043 21.7071 5.29289C21.5196 5.10536 21.2652 5 21 5ZM10 23V7H20V23H10Z",
    fill: "url(#paint4_linear_668_56275)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 21,
    r: 1,
    fill: "url(#paint5_linear_668_56275)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 8,
    width: 8,
    height: 11,
    rx: 1,
    fill: "url(#paint6_linear_668_56275)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45 23.2667L49.95 18.4826C50.9289 17.5364 51.5955 16.3309 51.8656 15.0185C52.1356 13.7062 51.9969 12.3459 51.4671 11.1097C50.9373 9.87351 50.04 8.81692 48.8889 8.07355C47.7378 7.33018 46.3844 6.93341 45 6.93341C43.6156 6.93341 42.2622 7.33018 41.1111 8.07355C39.96 8.81692 39.0628 9.87351 38.5329 11.1097C38.0031 12.3459 37.8644 13.7062 38.1345 15.0185C38.4045 16.3309 39.0711 17.5364 40.05 18.4826L45 23.2667ZM45 26L38.636 19.8492C37.3773 18.6327 36.5202 17.0828 36.1729 15.3954C35.8257 13.7081 36.0039 11.9591 36.6851 10.3697C37.3663 8.78026 38.5198 7.42175 39.9999 6.46595C41.4799 5.51015 43.22 5 45 5C46.78 5 48.5201 5.51015 50.0001 6.46595C51.4802 7.42175 52.6337 8.78026 53.3149 10.3697C53.9961 11.9591 54.1743 13.7081 53.8271 15.3954C53.4798 17.0828 52.6227 18.6327 51.364 19.8492L45 26V26ZM45 15.6314C45.5304 15.6314 46.0391 15.4278 46.4142 15.0652C46.7893 14.7027 47 14.2111 47 13.6984C47 13.1857 46.7893 12.6941 46.4142 12.3316C46.0391 11.9691 45.5304 11.7654 45 11.7654C44.4696 11.7654 43.9609 11.9691 43.5858 12.3316C43.2107 12.6941 43 13.1857 43 13.6984C43 14.2111 43.2107 14.7027 43.5858 15.0652C43.9609 15.4278 44.4696 15.6314 45 15.6314ZM45 17.5644C43.9391 17.5644 42.9217 17.1571 42.1716 16.4321C41.4214 15.7071 41 14.7237 41 13.6984C41 12.6731 41.4214 11.6898 42.1716 10.9647C42.9217 10.2397 43.9391 9.83242 45 9.83242C46.0609 9.83242 47.0783 10.2397 47.8284 10.9647C48.5786 11.6898 49 12.6731 49 13.6984C49 14.7237 48.5786 15.7071 47.8284 16.4321C47.0783 17.1571 46.0609 17.5644 45 17.5644Z",
    fill: "url(#paint7_linear_668_56275)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108 5.00001C108.702 4.99992 109.392 5.18474 110 5.53587C110.609 5.887 111.114 6.39207 111.465 7.0003C111.816 7.60853 112.001 8.29847 112 9.00075C112 9.70304 111.815 10.3929 111.464 11.001L116 11V13H114V23C114 23.2652 113.895 23.5196 113.707 23.7071C113.52 23.8946 113.265 24 113 24H97C96.7348 24 96.4804 23.8946 96.2929 23.7071C96.1054 23.5196 96 23.2652 96 23V13H94V11L98.536 11.001C98.0399 10.1419 97.8807 9.12906 98.0894 8.15918C98.2981 7.1893 98.8597 6.33157 99.6653 5.75256C100.471 5.17354 101.463 4.91456 102.449 5.02588C103.435 5.13721 104.344 5.61091 105 6.35501C105.375 5.92839 105.836 5.58678 106.353 5.35308C106.871 5.11939 107.432 4.99901 108 5.00001V5.00001ZM104 13H98V22H104V13ZM112 13H106V22H112V13ZM102 7.00001C101.481 6.99768 100.981 7.19719 100.607 7.55639C100.232 7.91558 100.012 8.40632 99.9925 8.92495C99.973 9.44357 100.156 9.94945 100.502 10.3357C100.849 10.722 101.332 10.9584 101.85 10.995L102 11H104V9.00001C104 8.52207 103.829 8.05992 103.518 7.69726C103.206 7.33461 102.775 7.09541 102.303 7.02301L102.149 7.00501L102 7.00001ZM108 7.00001C107.495 6.99985 107.009 7.19041 106.639 7.5335C106.269 7.87659 106.043 8.34685 106.005 8.85001L106 9.00001V11H108C108.505 11.0002 108.991 10.8096 109.361 10.4665C109.731 10.1234 109.957 9.65316 109.995 9.15001L110 9.00001C110 8.46957 109.789 7.96087 109.414 7.58579C109.039 7.21072 108.53 7.00001 108 7.00001V7.00001Z",
    fill: "url(#paint8_linear_668_56275)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_668_56275",
    x1: 69.9341,
    y1: 24.9998,
    x2: 69.9341,
    y2: 8.22119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28BEC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1743FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_668_56275",
    x1: 69.9341,
    y1: 24.9998,
    x2: 69.9341,
    y2: 8.22119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28BEC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1743FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_668_56275",
    x1: 80.0617,
    y1: 21.8288,
    x2: 80.0617,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28BEC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1743FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_668_56275",
    x1: 80.0617,
    y1: 21.8288,
    x2: 80.0617,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28BEC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1743FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_668_56275",
    x1: 15,
    y1: 25,
    x2: 15,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28BEC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1743FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_668_56275",
    x1: 15,
    y1: 22,
    x2: 15,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28BEC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1743FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_668_56275",
    x1: 15,
    y1: 19,
    x2: 15,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28BEC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1743FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_668_56275",
    x1: 45,
    y1: 26,
    x2: 45,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28BEC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1743FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_668_56275",
    x1: 105,
    y1: 24,
    x2: 105,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28BEC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1743FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceIconsEoeun);
export default __webpack_public_path__ + "static/media/place_icons_eoeun.6d5ed232fdee4e916a7e158fa67edea2.svg";
export { ForwardRef as ReactComponent };